import Vue from 'vue'
import Router from 'vue-router'

import Welcome from '@/views/Welcome'
import Settings from '@/views/Settings'
import Brewing from '@/views/Brewing'

import ReleaseNotes from '@/views/ReleaseNotes'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/brew/:tea/:brewStyle/:cup/:infusion',
      name: 'Brewing',
      props: true,
      component: Brewing
    },
    {
      path: '/brew-manual/:manual/:infusion',
      name: 'BrewingManual',
      props: true,
      component: Brewing
    },
    {
      path: '/brew-manual/:manual/:infusion/:manualInfusions',
      name: 'BrewingManualMaxInfusions',
      props: true,
      component: Brewing
    },
    {
      path: '/release-notes',
      name: 'ReleaseNotes',
      component: ReleaseNotes
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
